import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import Table from '../../../common/Table';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import { BAGGAGES_COLUMNS } from '../../../../config/columns';
import { clearBaggages, getBaggagesV2 } from '../../../../actions';
import { BAGGAGE_PATH } from '../../../../config/paths';

const BaggageSearchResult = ({
  loading,
  baggages,
  searchFormValues,
  dispatchGetBaggages,
  dispatchClearBaggages,
}) => {
  useEffect(() => dispatchClearBaggages(), []);

  const data = baggages.get('content') || [];
  const columns = BAGGAGES_COLUMNS;
  const pages = baggages.get('totalPages') || null;
  const defaultPageSize = baggages.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <div className="mt-3">
      <Table
        columns={columns}
        data={data}
        pages={pages}
        defaultPageSize={defaultPageSize}
        loading={loading}
        modelPath={BAGGAGE_PATH}
        navigateToModelOnRowClick
        fetchData={dispatchGetBaggages}
        params={searchFormValues}
        filterable
        groupedColumns
      />
    </div>
  );
};

const mapStateToProps = ({ BaggageUnit }) => ({
  loading: BaggageUnit.Baggage.getIn(['all', 'loading']),
  baggages: BaggageUnit.Baggage.getIn(['all', 'content']),
});

const mapDispatchToProps = {
  dispatchClearBaggages: clearBaggages,
  dispatchGetBaggages: getBaggagesV2,
};

BaggageSearchResult.propTypes = {
  baggages: PropTypes.instanceOf(Immutable.Map).isRequired,
  loading: PropTypes.bool,
  dispatchClearBaggages: PropTypes.func.isRequired,
  searchFormValues: PropTypes.shape({
    ticketCode: PropTypes.string,
    excessCode: PropTypes.string,
  }).isRequired,
  dispatchGetBaggages: PropTypes.func.isRequired,
};

BaggageSearchResult.defaultProps = {
  loading: false,
};

export { BaggageSearchResult };
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BaggageSearchResult);
